export const toBarHeight = (value: number, max = 100) =>
  Math.round((value / max) * 100);
